<p-toast position="bottom-right"></p-toast>
<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>
<div class="card m-1">

  <div class="card-header bg-gradient-gray-dark text-orange">
    <strong>{{lineName}} &nbsp;{{quoteId}}</strong>&nbsp;
  </div>
  <div class="card-body">

    <div class="row">
      <img *ngIf="notExist" src="../../../../assets/error404.jpg" />
    </div>

    <p-table *ngIf="!notExist" [value]="ticketsOfLine" [tableStyle]="{'min-width': '60rem'}" [styleClass]="'p-datatable-sm'">
      <ng-template pTemplate="header">
        <tr>
          <th>Ticket ID</th>
          <th>Open Date</th>
          <!--<th>Close Date</th>-->
          <th>Status</th>
          <!--<th>area</th>
          <th>subArea</th>
          <th>eCode</th>
          <th>eDesc</th>-->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-ticket>
        <tr>
          <td>{{ticket.srNumber}}</td>
          <td>{{ticket.openedDate | date:'yyyy-MM-dd'}}</td>
          <!--<td>{{ticket.closedDate | date:'yyyy-MM-dd'}}</td>-->
          <td><p-tag [value]="getLineStatus(ticket)" [severity]="getSeverity(ticket)"></p-tag></td>
          <!--<td>{{ticket.area}}</td>
          <td>{{ticket.subArea}}</td>
          <td>{{ticket.eCode}}</td>
          <td>{{ticket.eDesc}}</td>-->
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          In total there are {{ticketsOfLine ? ticketsOfLine.length : 0 }} tickets.
        </div>
      </ng-template>
    </p-table>
    <!--<div class="row" style="text-align:right">
    <a href="#/linedetails/{{tmpid}}" class="card-link" style="text-align:right"><i class="fas fa-arrow-left"></i></a>
  </div>-->
     
    

  </div>

</div>
